export default function ProductFeatures() {
  const features = [
    {
      icon: 'ri-code-line',
      title: '开发者友好',
      description: '提供完整的SDK和API文档，支持多种编程语言，让开发者能够快速集成PDF功能到应用中。',
      benefits: ['详细文档', '代码示例', '技术支持', '社区论坛']
    },
    {
      icon: 'ri-shield-check-line',
      title: '企业级安全',
      description: '符合国际安全标准，提供端到端加密、数字签名和访问控制，保障企业文档安全。',
      benefits: ['数据加密', '合规认证', '访问控制', '审计日志']
    },
    {
      icon: 'ri-cloud-line',
      title: '云端部署',
      description: '支持公有云、私有云和混合云部署，提供弹性扩展和高可用性保障。',
      benefits: ['弹性扩展', '高可用性', '全球CDN', '自动备份']
    },
    {
      icon: 'ri-customer-service-line',
      title: '专业服务',
      description: '提供7x24小时技术支持、定制开发服务和专业培训，确保客户成功实施。',
      benefits: ['技术支持', '定制开发', '专业培训', '实施指导']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">产品优势</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            我们的产品不仅功能强大，更注重用户体验和企业级需求，为您提供全方位的文档处理解决方案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-600 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{feature.description}</p>
              <div className="space-y-2">
                {feature.benefits.map((benefit, benefitIndex) => (
                  <div key={benefitIndex} className="flex items-center justify-center text-sm text-gray-500">
                    <i className="ri-check-line text-emerald-500 mr-2"></i>
                    {benefit}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-3xl p-8 lg:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">为什么选择我们？</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                作为PDF文档处理领域的专业厂商，我们拥有多年的技术积累和丰富的行业经验，为全球超过10,000家企业提供服务。
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">800+</div>
                  <div className="text-gray-600">企业客户</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">99.9%</div>
                  <div className="text-gray-600">服务可用性</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">50+</div>
                  <div className="text-gray-600">国家和地区</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">8x7</div>
                  <div className="text-gray-600">技术支持</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/16f5ee5b716b9e7411497165a40fc3a1.jpg"
                alt="团队协作"
                className="w-full h-80 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}